import { Loader } from '@mantine/core'
import {
  IconBuilding,
  IconBuildingEstate,
  IconCalculator,
  IconCalendar,
  IconCalendarCheck,
  IconCancel,
  IconCashRegister,
  IconChevronLeft,
  IconCloud,
  IconCloudFilled,
  IconCloudRain,
  IconCoin,
  IconCoinEuro,
  IconCoins,
  IconDeviceFloppy,
  IconDeviceMobile,
  IconDevices2,
  IconDownload,
  IconDroplets,
  IconDropletsFilled,
  IconEye,
  IconFileTypePdf,
  IconFileTypeXls,
  IconGasStation,
  IconHome,
  IconImageInPicture,
  IconLock,
  IconLockDollar,
  IconLockFilled,
  IconLockOpen,
  IconLockOpen2,
  IconMail,
  IconMapPin,
  IconMapPin2,
  IconMapPinFilled,
  IconNetwork,
  IconPhone,
  IconPhoto,
  IconPlayBasketball,
  IconPlayerPlay,
  IconPlayerPlayFilled,
  IconPlus,
  IconQuestionMark,
  IconRefreshAlert,
  IconRestore,
  IconSearch,
  IconSend,
  IconShoppingBagCheck,
  IconSnowflake,
  IconSnowflakeOff,
  IconSum,
  IconSunHigh,
  IconSunHighFilled,
  IconSunLow,
  IconSunLowFilled,
  IconTaxEuro,
  IconTemperatureCelsius,
  IconTemperaturePlus,
  IconTemperatureSun,
  IconTextPlus,
  IconTool,
  IconTrash,
  IconUpload,
  IconUserExclamation,
  type Icon,
} from '@tabler/icons-react'

import { ReactComponent as HomeIcon } from '../../assets/icons/home.svg'
import { ReactComponent as CenterIcon } from '../../assets/icons/center.svg'
import { ReactComponent as FuelIcon } from '../../assets/icons/fuel.svg'
import { ReactComponent as FuelPurchaseIcon } from '../../assets/icons/fuel-purchase.svg'
import { ReactComponent as AccountingEntryIcon } from '../../assets/icons/accounting-entry.svg'
import { ReactComponent as ConfigIcon } from '../../assets/icons/config.svg'
import React from 'react'

interface CustomProps extends Icon {
  icon?:
    | 'center'
    | 'fuel'
    | 'fuel-purchase'
    | 'accounting-entry'
    | 'config'
    | 'pi-spinner pi-spin'
    | 'home'
    | 'plus'
    | 'back'
    | 'search'
    | 'cashregister'
    | 'centerNew'
    | 'pi-save'
    | 'pi-trash'
    | 'pi-plus'
    | 'pi-play'
    | 'pi-eye'
  size?: string
  color?: string
}

const AppIcon = ({
  icon = 'home',
  size = 'xs',
  color,
  ...otherProps
}: CustomProps) => {
  const icons = {
    /* Legacy */
    center: CenterIcon,
    fuel: FuelIcon,
    'fuel-purchase': FuelPurchaseIcon,
    'accounting-entry': AccountingEntryIcon,
    config: ConfigIcon,
    'pi-spinner pi-spin': <Loader type="oval" size={22} color="white" />,

    'pi-save': IconDeviceFloppy,
    'pi-trash': IconTrash,
    'pi-plus': IconPlus,
    'pi-play': IconPlayerPlay,
    'pi-eye': IconEye,

    /* New */

    eye: IconEye,
    play: IconPlayerPlay,
    loader: <Loader type="oval" size={22} color="white" />,
    locked: IconLockFilled,
    unlocked: IconLockOpen2,

    home: IconHome,
    save: IconDeviceFloppy,
    cancel: IconCancel,
    reset: IconRestore,
    remove: IconTrash,
    add: IconPlus,
    plus: IconPlus,
    back: IconChevronLeft,
    search: IconSearch,
    cashregister: IconCashRegister,

    centerNew: IconMapPinFilled,
    computer: IconDevices2,
    internet: IconNetwork,

    download: IconDownload,
    calendar: IconCalendar,
    year: IconCalendarCheck,
    excel: IconFileTypeXls,
    pdf: IconFileTypePdf,
    image: IconPhoto,
    upload: IconUpload,

    cashRegistersClose: IconLockDollar,
    sum: IconSum,
    calc: IconCalculator,
    text: IconTextPlus,
    play: IconPlayerPlayFilled,
    send: IconSend,

    weather: IconTemperatureSun,
    sunny: IconSunHighFilled,
    cloudy: IconCloudFilled,
    sunnyCloudy: IconCloud,
    snowy: IconSnowflake,
    rainy: IconCloudRain,

    expense: IconCoins,
    salesType: IconCashRegister,
    supplier: IconShoppingBagCheck,
    total: IconSum,

    question: IconQuestionMark,

    activityType: IconBuildingEstate,

    supervisor: IconUserExclamation,

    zone: IconMapPin,
    province: IconMapPin,
    email: IconMail,
    phone: IconPhone,
    mobile: IconDeviceMobile,
    company: IconBuilding,
    accountingEntryCompany: IconBuilding,

    soap: IconDropletsFilled,
    gas: IconGasStation,
    ownFuelStation: IconGasStation,
    heater: IconTemperatureCelsius,
    technics: IconTool,
    floorHeating: IconTemperaturePlus,
    antiIceRecovery: IconSnowflakeOff,

    euro: IconCoinEuro,
    synch: IconRefreshAlert,
  }

  const IconComponent = icons?.[icon] || icons.question

  if (React.isValidElement(IconComponent)) {
    return React.cloneElement(IconComponent, {
      ...otherProps,
      ...(color && { color }),
      ...(size && { size }),
    })
  }
  return (
    <IconComponent
      {...otherProps}
      color={color}
      // {...otherProps}
      // color={color}
      // size={size}
    />
  )
}

export default AppIcon
